let icons = null;

export function useIcons() {
    if (!icons) {
        icons = import.meta.glob('../../../**/*.svg', { query: '?raw', import: 'default' });
        icons = Object.keys(icons).reduce((map, path) => {
            // Extract the icon name from the path
            const iconName = path.split('../').pop().replace('.svg', '');
            map[iconName] = icons[path];
            return map;
        }, {});
    }

    return icons;
}
